<template>
  <header id="header" class="bg-white py-3 shadow-sm border-b border-gray-200 mx-auto">
    <div class="ml-20 px-0 flex justify-between">
      <div class="flex items-center">
        <h3 class="bg-brand text-2xl text-center text-green-800">
          <i class="fa-solid fa-fingerprint text-green-800 font-bold"></i>
          ether<span class="font-bold">.id</span>
        </h3>
      </div>
      <nav class="md:flex space-x-6 items-center mr-20">
        <div v-if="isPublic" class="flex items-center space-x-2">
          <i class="fa-solid fa-wallet text-green-600 text-sm"></i>
          <span v-if="billingStore.balanceLoading" class="text-gray-400 text-sm">Loading...</span>
          <span v-else class="text-sm font-semibold text-gray-700">
            UGX {{ billingStore.balance !== null ? Number(billingStore.balance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '—' }}
          </span>
        </div>
        <div v-if="authStore.user && authStore.user.firstName" class="flex items-center ml-6">
          <span class="text-gray-700 text-sm">{{ authStore.user.firstName }} {{ authStore.user.lastName }}</span>
        </div>
      </nav>
      <div class="md:hidden">
        <button class="text-gray-700" type="button">
          <i class="fa-solid fa-bars"></i>
        </button>
      </div>
    </div>
  </header>
</template>
<script setup lang="ts">
import { onMounted, computed } from 'vue';
import { useAuthStore } from '@/store/auth';
import { useBillingStore } from '@/store/billing';

const authStore = useAuthStore();
const billingStore = useBillingStore();

const isPublic = computed(() => localStorage.getItem('purpose') === 'public');

onMounted(() => {
  if (isPublic.value) {
    billingStore.fetchPublicBalance();
  }
});
</script>
